<div class="side-nav-container">
  <mat-nav-list>
    <ng-container *authGroup="currentRoles">

      <mat-list-item [routerLink]="dashboard.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
        *authGroup="dashboard.access">
        <mat-icon mat-list-icon>{{dashboard.icon}}</mat-icon>
        <a mat-line>{{dashboard.label}}</a>
      </mat-list-item>

      <mat-expansion-panel [hideToggle]="!stocktake.expanded" (opened)="stocktake.expanded=true"
        (closed)="stocktake.expanded=false" *authGroup="stocktake.access">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon inline class="me-2">history_edu</mat-icon> {{stocktake.label}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of stocktake.links; track link) {
          <mat-list-item [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon mat-list-icon>{{link.icon}}</mat-icon>
            <a mat-line>{{link.label}}</a>
          </mat-list-item>
        }
      </mat-expansion-panel>

      <!-- <mat-list-item [routerLink]="stocktake.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
      *authGroup="stocktake.access">
      <mat-icon mat-list-icon>history_edu</mat-icon>
      <a mat-line>{{stocktake.label}}</a>
    </mat-list-item> -->

    <mat-accordion class="example-headers-align">

      <mat-expansion-panel [hideToggle]="!prescription.expanded" (opened)="prescription.expanded=true"
        (closed)="prescription.expanded=false" *authGroup="prescription.access">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon inline class="me-2">library_books</mat-icon> Prescriptions
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of prescription.links; track link) {
          <mat-list-item [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon mat-list-icon>{{link.icon}}</mat-icon>
            <a mat-line>{{link.label}}</a>
          </mat-list-item>
        }
      </mat-expansion-panel>


      <mat-expansion-panel [hideToggle]="!batch.expanded" (opened)="batch.expanded=true"
        (closed)="batch.expanded=false" *authGroup="batch.access">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon inline class="me-2">layers</mat-icon> Batches
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of batch.links; track link) {
          <mat-list-item [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon mat-list-icon>{{link.icon}}</mat-icon>
            <a mat-line>{{link.label}}</a>
          </mat-list-item>
        }
      </mat-expansion-panel>


      <mat-divider *authGroup="individual.access"></mat-divider>


      <mat-expansion-panel [hideToggle]="!individual.expanded" (opened)="individual.expanded=true"
        (closed)="individual.expanded=false" *authGroup="individual.access">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon inline class="me-2">people</mat-icon> Individuals
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of individual.links; track link) {
          <mat-list-item [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon mat-list-icon>{{link.icon}}</mat-icon>
            <a mat-line>{{link.label}}</a>
          </mat-list-item>
        }
      </mat-expansion-panel>


      <mat-expansion-panel [hideToggle]="!company.expanded" (opened)="company.expanded=true"
        (closed)="company.expanded=false" *authGroup="company.access">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon inline class="me-2">business</mat-icon> Companies
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of company.links; track link) {
          <mat-list-item [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon mat-list-icon>{{link.icon}}</mat-icon>
            <a mat-line>{{link.label}}</a>
          </mat-list-item>
        }
      </mat-expansion-panel>


      <mat-expansion-panel [hideToggle]="!medicine.expanded" (opened)="medicine.expanded=true"
        (closed)="medicine.expanded=false" *authGroup="medicine.access">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon inline class="me-2">medication</mat-icon> Medicine
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of medicine.links; track link) {
          <mat-list-item [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon mat-list-icon>{{link.icon}}</mat-icon>
            <a mat-line>{{link.label}}</a>
          </mat-list-item>
        }
      </mat-expansion-panel>

      <!-- <mat-expansion-panel [hideToggle]="!ordermedicine.expanded" (opened)="ordermedicine.expanded=true"
      (closed)="ordermedicine.expanded=false" *authGroup="ordermedicine.access">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon inline class="me-2">medication</mat-icon> Order Medicine
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngFor="let link of ordermedicine.links">
        <mat-list-item [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
          *authGroup="link.access">
          <mat-icon mat-list-icon>{{link.icon}}</mat-icon>
          <a mat-line>{{link.label}}</a>
        </mat-list-item>
      </ng-container>
    </mat-expansion-panel> -->

    <mat-divider *authGroup="systemManagement.access"></mat-divider>

    <mat-expansion-panel [hideToggle]="!systemManagement.expanded" (opened)="systemManagement.expanded=true"
      (closed)="systemManagement.expanded=false" *authGroup="systemManagement.access">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon inline class="me-2">tune</mat-icon> System management
        </mat-panel-title>
      </mat-expansion-panel-header>
      @for (link of systemManagement.links; track link) {
        <mat-list-item [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
          *authGroup="link.access">
          <mat-icon mat-list-icon>{{link.icon}}</mat-icon>
          <a mat-line>{{link.label}}</a>
        </mat-list-item>
      }
    </mat-expansion-panel>

    <mat-expansion-panel [hideToggle]="!user.expanded" (opened)="user.expanded=true" (closed)="user.expanded=false"
      *authGroup="user.access">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon inline class="me-2">people</mat-icon> User management
        </mat-panel-title>
      </mat-expansion-panel-header>
      @for (link of user.links; track link) {
        <mat-list-item [routerLink]="link.route" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active"
          *authGroup="link.access">
          <mat-icon mat-list-icon>{{link.icon}}</mat-icon>
          <a mat-line>{{link.label}}</a>
        </mat-list-item>
      }
    </mat-expansion-panel>

    @if (sageUiEnabled) {
      <mat-expansion-panel [hideToggle]="!sage.expanded" (opened)="sage.expanded=true" (closed)="sage.expanded=false"
        *authGroup="sage.access">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon inline class="me-2">sync_alt</mat-icon> {{ sage.label }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (link of sage.links; track link) {
          <mat-list-item [routerLink]="link.route" [routerLinkActiveOptions]="{exact: false}" routerLinkActive="active"
            *authGroup="link.access">
            <mat-icon mat-list-icon>{{ link.icon }}</mat-icon>
            <a mat-line>{{ link.label }}</a>
          </mat-list-item>
        }
      </mat-expansion-panel>
    }

  </mat-accordion>
</ng-container>
</mat-nav-list>
</div>